/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnReferralBody
 */
export interface EarnReferralBody {
    /**
     * 
     * @type {string}
     * @memberof EarnReferralBody
     */
    objectiveTemplateId: string;
    /**
     * 
     * @type {string}
     * @memberof EarnReferralBody
     */
    recipientEmail: string;
    /**
     * 
     * @type {string}
     * @memberof EarnReferralBody
     */
    recipientFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof EarnReferralBody
     */
    recipientLastName?: string;
    /**
     * The inviter's own name for the email's sender identity. Overridden by the policy's inviteFromName when one is configured.
     * @type {string}
     * @memberof EarnReferralBody
     */
    fromName?: string;
}

/**
 * Check if a given object implements the EarnReferralBody interface.
 */
export function instanceOfEarnReferralBody(value: object): value is EarnReferralBody {
    if (!('objectiveTemplateId' in value) || value['objectiveTemplateId'] === undefined) return false;
    if (!('recipientEmail' in value) || value['recipientEmail'] === undefined) return false;
    return true;
}

export function EarnReferralBodyFromJSON(json: any): EarnReferralBody {
    return EarnReferralBodyFromJSONTyped(json, false);
}

export function EarnReferralBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnReferralBody {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'],
        'recipientEmail': json['recipientEmail'],
        'recipientFirstName': json['recipientFirstName'] == null ? undefined : json['recipientFirstName'],
        'recipientLastName': json['recipientLastName'] == null ? undefined : json['recipientLastName'],
        'fromName': json['fromName'] == null ? undefined : json['fromName'],
    };
}

export function EarnReferralBodyToJSON(json: any): EarnReferralBody {
    return EarnReferralBodyToJSONTyped(json, false);
}

export function EarnReferralBodyToJSONTyped(value?: EarnReferralBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'recipientEmail': value['recipientEmail'],
        'recipientFirstName': value['recipientFirstName'],
        'recipientLastName': value['recipientLastName'],
        'fromName': value['fromName'],
    };
}

